import GaEvent from './GaEvent';

export default class ItineraryItemAddedGaEvent extends GaEvent {
  constructor() {
    super('itinerary_item_added');
  }

  addItineraryId(value: number | string) {
    this.addParam('itinerary_id', String(value));

    return this;
  }

  addItineraryName(value: string) {
    this.addParam('itinerary_name', value);

    return this;
  }

  addItemId(value: number | string) {
    this.addParam('item_id', String(value));

    return this;
  }

  addItemType(value: string) {
    this.addParam('item_type', value);

    return this;
  }

  addItemName(value: string) {
    this.addParam('item_name', value);

    return this;
  }
}
